import { render } from "./TopHat.vue?vue&type=template&id=9a7fd3a4&scoped=true"
import script from "./TopHat.vue?vue&type=script&lang=js"
export * from "./TopHat.vue?vue&type=script&lang=js"

import "./TopHat.vue?vue&type=style&index=0&id=9a7fd3a4&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9a7fd3a4"]])

export default __exports__